import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Class composition.
 *
 * `twMerge` is what makes variant props safe: a component can ship
 * `px-3 py-2` and a caller can pass `px-6` without ending up with both in the
 * class string and the cascade deciding at random.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
